import(/* webpackMode: "eager" */ "/vercel/path0/apps/traeger/app/~p/[pageNumber]/[country]/[lang]/error.tsx");
